var update = require("!../../node_modules/.pnpm/style-loader@0.23.1/node_modules/style-loader/lib/addStyleUrl.js")(
  require("!!../../node_modules/.pnpm/file-loader@3.0.1_webpack@4.29.6/node_modules/file-loader/dist/cjs.js!./tabs.css")
, {"hmr":true});
if(module.hot) {
  module.hot.accept("!!../../node_modules/.pnpm/file-loader@3.0.1_webpack@4.29.6/node_modules/file-loader/dist/cjs.js!./tabs.css", function() {
    update(require("!!../../node_modules/.pnpm/file-loader@3.0.1_webpack@4.29.6/node_modules/file-loader/dist/cjs.js!./tabs.css"));
  });

  module.hot.dispose(function() { update(); });
}